import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.user.list');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-user-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.user.list/view.scss */
/* src/app/portal.gsdcadmin.user.list/view.scss: no such file or directory */`],
})
export class PortalGsdcadminUserListComponent implements OnInit, OnDestroy {
    @Input() view: any;
    @ViewChild('switchDialog') switchDialog: ElementRef<HTMLDialogElement>;
    public selectedRole = 'all';
    public selectedStatus = 'active';
    public selectedCommunity = '';
    public searchTerm = '';
    public users: any[] = [];
    public communities: any[] = [];
    public page = 1;
    public lastpage = 1;
    public total = 0;
    public loading = false;
    public failed = false;
    public open = false;
    public switchTarget: any = null;
    public switching = false;
    public switchError = '';
    private request = 0;
    private searchTimer: any;
    public roleLabels: any = {admin:'시스템 관리자',manager:'서비스 담당자',leader:'커뮤니티 대표',pi:'그룹 대표(PI)',user:'개인연구자'};
    public statusLabels: any = {active:'활성',pending:'승인 대기',join:'가입 진행 중',reject:'거절',inactive:'비활성'};
    constructor(@Inject( Service) public service: Service) { }
    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('admin','/dashboard');
        const query = new URLSearchParams(window.location.search);
        this.selectedRole = query.get('role') || 'all';
        this.selectedStatus = query.get('status') || 'active';
        this.selectedCommunity = query.get('community') || '';
        this.searchTerm = query.get('text') || '';
        this.page = Math.max(1, Number(query.get('page')) || 1);
        await this.load();
    }
    public ngOnDestroy() { this.request++; clearTimeout(this.searchTimer); this.switchDialog?.nativeElement.close(); }
    public search() { clearTimeout(this.searchTimer); this.searchTimer = setTimeout(() => this.filter(), 250); }
    public async filter() { clearTimeout(this.searchTimer); this.page = 1; await this.load(); }
    public async load() {
        const request = ++this.request;
        this.loading = true; this.failed = false;
        await this.service.render();
        try {
            const params = {role:this.selectedRole,status:this.selectedStatus,community:this.selectedCommunity,text:this.searchTerm,page:this.page};
            const {code,data} = await wiz.call('load',params);
            if (request !== this.request) return;
            if (code !== 200 || !Array.isArray(data?.rows)) throw new Error('load');
            this.users = data.rows; this.communities = data.communities;
            this.total = data.total; this.page = data.page; this.lastpage = data.lastpage;
            const url = new URL(window.location.href);
            for (const [key,value] of Object.entries({...params,page:this.page})) value === '' ? url.searchParams.delete(key) : url.searchParams.set(key,String(value));
            window.history.replaceState(window.history.state,'',url.toString());
        } catch (_) { if (request === this.request) { this.failed = true; this.users = []; } }
        finally { if (request === this.request) { this.loading = false; await this.service.render(); } }
    }
    public get pages() { const start = Math.max(1,Math.min(this.page-2,this.lastpage-4)); return Array.from({length:Math.min(5,this.lastpage)},(_,i)=>start+i); }
    public async changePage(page: number) { if (this.loading || page < 1 || page > this.lastpage) return; this.page=page; await this.load(); }
    public async closeModal(value: boolean) { this.open=value; await this.load(); }
    public async openSwitch(user: any) {
        if (!user.can_switch || this.switchTarget) return;
        this.switchTarget=user; this.switchError='';
        await this.service.render(); this.switchDialog.nativeElement.showModal();
    }
    public async closeSwitch(event?: Event) {
        event?.preventDefault(); if (this.switching) return;
        this.switchDialog.nativeElement.close(); this.switchTarget=null; await this.service.render();
    }
    public switchKey(event: KeyboardEvent) {
        if (event.key !== 'Tab') return;
        const buttons=Array.from(this.switchDialog.nativeElement.querySelectorAll<HTMLButtonElement>('button:not(:disabled)'));
        if (!buttons.length) { event.preventDefault(); return; }
        if(event.shiftKey && document.activeElement===buttons[0]) {event.preventDefault();buttons[buttons.length-1].focus();}
        else if(!event.shiftKey && document.activeElement===buttons[buttons.length-1]) {event.preventDefault();buttons[0].focus();}
    }
    public async switchUser() {
        if (this.switching || !this.switchTarget) return;
        this.switching=true; await this.service.render();
        try {
            const {code,data}=await wiz.call('switch',{user_id:this.switchTarget.id});
            if(code!==200) throw new Error(typeof data==='string'?data:'사용자 전환에 실패했습니다.');
            window.location.assign(data.redirect);
        } catch(error) {this.switchError=error.message;this.switching=false;await this.service.render();}
    }
}

export default PortalGsdcadminUserListComponent;